<template>
  <div class="recommendation-container">
    <div class="rec-title">为您推荐：</div>
    <div class="rec-list">
      <div v-for="(item, idx) in recommendations" :key="idx" class="rec-card" @click="showBrandDetail(item)">
        <!-- Brand Info Header -->
        <div class="rec-main-info">
          <div class="rec-logo">
            <img v-if="item.logo" :src="item.logo" :alt="item.name" @error="handleImageError">
            <span v-else class="logo-placeholder">{{ item.name ? item.name[0] : '' }}</span>
          </div>
          <div class="rec-info">
            <div class="rec-name">{{ item.name }}</div>
            <div class="rec-floor">{{ item.floor || (item.map_floor ? item.map_floor + '层' : '') }}</div>
          </div>
          <div class="rec-actions">
            <button class="action-btn detail-btn" @click.stop="showBrandDetail(item)">详情</button>
            <button class="action-btn nav-btn-small" @click.stop="startNavigation(item)">导航</button>
          </div>
        </div>
        
        <!-- Goods Recommendation List -->
        <div v-if="item.goods_list && item.goods_list.length > 0 && item.goods_count > 0" class="rec-goods-list">
          <div v-for="(goods, gIdx) in item.goods_list" :key="gIdx" class="rec-goods-item" @click.stop="showProductDetail(goods)">
            <div class="goods-img">
              <img :src="goods.cover" :alt="goods.goods_name" @error="handleImageError">
            </div>
            <div class="goods-name">{{ goods.goods_name }}</div>
            <div class="goods-price">¥{{ goods.price }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Brand Detail Modal -->
    <teleport to="body">
      <transition name="fade">
        <div v-if="selectedBrand" class="brand-modal-overlay" @click="selectedBrand = null">
          <div class="brand-modal" @click.stop>
            <button class="close-modal-btn" @click="selectedBrand = null">×</button>
            <div class="modal-header">
              <div class="modal-logo">
                 <img v-if="selectedBrand.logo" :src="selectedBrand.logo" :alt="selectedBrand.name" @error="handleImageError">
                 <span v-else class="logo-placeholder">{{ selectedBrand.name ? selectedBrand.name[0] : '' }}</span>
              </div>
              <div class="modal-title">
                <h2>{{ selectedBrand.name }}</h2>
                <span class="modal-floor">{{ selectedBrand.floor || (selectedBrand.map_floor ? selectedBrand.map_floor + '层' : '') }}</span>
              </div>
            </div>
            <div class="modal-body">
              <p>{{ selectedBrand.description || selectedBrand.intro || '暂无介绍' }}</p>
              
              <!-- Also show goods in brand modal if desired, currently sticking to existing layout + logic -->
            </div>
            <div class="modal-footer">
              <button class="nav-btn" @click="startNavigation(selectedBrand)">
                <span class="icon">📍</span> 开始导航
              </button>
            </div>
          </div>
        </div>
      </transition>
    </teleport>

    <!-- Product Detail Modal -->
    <teleport to="body">
      <transition name="fade">
        <div v-if="selectedProduct" class="brand-modal-overlay" @click="selectedProduct = null">
          <div class="brand-modal product-modal" @click.stop>
            <button class="close-modal-btn" @click="selectedProduct = null">×</button>
            <div class="product-content">
              <div class="product-cover-large">
                <img :src="selectedProduct.cover" :alt="selectedProduct.goods_name" @error="handleImageError">
              </div>
              <div class="product-header">
                <h2 class="product-title">{{ selectedProduct.goods_name }}</h2>
                <div class="product-price-large">¥{{ selectedProduct.price }}</div>
              </div>
              <div class="product-desc">
                {{ selectedProduct.intro || '暂无商品介绍' }}
              </div>
            </div>
          </div>
        </div>
      </transition>
    </teleport>
  </div>
</template>

<script>
export default {
  name: 'RecommendationList',
  props: {
    recommendations: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  emits: ['navigate'],
  data() {
    return {
      selectedBrand: null,
      selectedProduct: null
    }
  },
  methods: {
    showBrandDetail(brand) {
      this.selectedBrand = brand;
    },
    showProductDetail(goods) {
      this.selectedProduct = goods;
    },
    startNavigation(brand) {
      this.$emit('navigate', {
        name: brand.name,
        floor_id: parseInt(brand.map_floor),
        x: parseFloat(brand.map_x),
        y: parseFloat(brand.map_y)
      });
      this.selectedBrand = null;
    },
    handleImageError(e) {
      e.target.style.display = 'none';
    }
  }
}
</script>

<style scoped>
.recommendation-container {
  margin-top: 1vh;
  width: 100%;
}

.rec-title {
  font-size: 0.8rem;
  color: #666;
  margin-bottom: 1vh;
  font-weight: bold;
}

.rec-list {
  display: flex;
  flex-direction: column;
  gap: 1vh;
}

.rec-card {
  display: flex;
  flex-direction: column; /* Changed for layout */
  background: #fff;
  padding: 1vh;
  border-radius: 1vh;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  border: 1px solid rgba(0,0,0,0.02);
}

.rec-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.rec-main-info {
  display: flex;
  align-items: center;
  width: 100%;
}

.rec-logo {
  width: 4vh;
  height: 4vh;
  border-radius: 0.6vh;
  background: #f8f8f8;
  overflow: hidden;
  margin-right: 1vh;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #eee;
  flex-shrink: 0;
}

.rec-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.logo-placeholder {
  font-size: 1.2rem;
  color: #d14d5e;
  font-weight: bold;
}

.rec-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.rec-name {
  font-size: 0.9rem;
  color: #333;
  font-weight: bold;
  line-height: 1.2;
}

.rec-floor {
  font-size: 0.75rem;
  color: #999;
  margin-top: 0.3vh;
}

/* Goods List Styles */
.rec-goods-list {
  display: flex;
  gap: 1vh;
  margin-top: 1vh;
  padding-top: 1vh;
  border-top: 1px dashed #eee;
  overflow-x: auto;
  padding-bottom: 0.5vh;
}

.rec-goods-list::-webkit-scrollbar {
  height: 0;
  width: 0;
}

.rec-goods-item {
  flex: 0 0 10vh;
  display: flex;
  flex-direction: column;
  gap: 0.5vh;
  transition: opacity 0.2s;
}

.rec-goods-item:hover {
  opacity: 0.8;
}

.goods-img {
  width: 100%;
  aspect-ratio: 1;
  border-radius: 0.6vh;
  background: #f8f8f8;
  overflow: hidden;
  border: 1px solid #eee;
}

.goods-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.goods-name {
  font-size: 0.75rem;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.goods-price {
  font-size: 0.75rem;
  color: #d14d5e;
  font-weight: bold;
}

/* Brand Modal Styles */
.brand-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(2px);
}

.brand-modal {
  width: 80%;
  max-width: 400px;
  background: #fff;
  border-radius: 1.5vh;
  padding: 2vh;
  position: relative;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  animation: modal-pop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes modal-pop {
  from { transform: scale(0.8); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.close-modal-btn {
  position: absolute;
  top: 1vh;
  right: 1vh;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #999;
  cursor: pointer;
  line-height: 1;
  padding: 0.5vh;
  z-index: 2;
}

.modal-header {
  display: flex;
  align-items: center;
  margin-bottom: 2vh;
}

.modal-logo {
  width: 6vh;
  height: 6vh;
  border-radius: 1vh;
  background: #f8f8f8;
  overflow: hidden;
  margin-right: 1.5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #eee;
  flex-shrink: 0;
}

.modal-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.modal-title h2 {
  margin: 0;
  font-size: 1.1rem;
  color: #333;
}

.modal-floor {
  font-size: 0.8rem;
  color: #999;
  display: inline-block;
  background: #f0f2f5;
  padding: 0.2vh 0.8vh;
  border-radius: 0.4vh;
  margin-top: 0.5vh;
}

.modal-body {
  margin-bottom: 2.5vh;
  font-size: 0.9rem;
  color: #666;
  line-height: 1.6;
  max-height: 20vh;
  overflow-y: auto;
}

.modal-footer {
  display: flex;
  justify-content: center;
}

.nav-btn {
  background: linear-gradient(135deg, #d14d5e 0%, #d65db1 100%);
  color: #fff;
  border: none;
  padding: 1.5vh 4vh;
  border-radius: 3vh;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8vh;
  box-shadow: 0 4px 12px rgba(209, 77, 94, 0.3);
  transition: transform 0.2s;
  width: 80%;
}

.nav-btn:active {
  transform: scale(0.95);
}

/* Product Modal Specifics */
.product-content {
  display: flex;
  flex-direction: column;
  gap: 1.5vh;
}

.product-cover-large {
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 1vh;
  overflow: hidden;
  background: #f8f8f8;
}

.product-cover-large img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.product-title {
  font-size: 1.1rem;
  font-weight: bold;
  color: #333;
  margin: 0;
  flex: 1;
}

.product-price-large {
  font-size: 1.2rem;
  color: #d14d5e;
  font-weight: bold;
  margin-left: 1vh;
}

.product-desc {
  font-size: 0.9rem;
  color: #666;
  line-height: 1.5;
  max-height: 15vh;
  overflow-y: auto;
}

.rec-actions {
  display: flex;
  gap: 0.8vh;
  margin-left: 1vh;
}

.action-btn {
  padding: 0.6vh 1.5vh;
  border-radius: 2vh;
  font-size: 0.8rem;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  font-weight: bold;
}

.detail-btn {
  background: #f0f2f5;
  color: #666;
}

.nav-btn-small {
  background: linear-gradient(135deg, #d14d5e 0%, #d65db1 100%);
  color: #fff;
  box-shadow: 0 2px 6px rgba(209, 77, 94, 0.3);
}

.nav-btn-small:active {
  transform: scale(0.95);
}
</style>